import { render, staticRenderFns } from "./sell-behind.vue?vue&type=template&id=507040bd&scoped=true"
import script from "./sell-behind.vue?vue&type=script&lang=js"
export * from "./sell-behind.vue?vue&type=script&lang=js"
import style0 from "./sell-behind.vue?vue&type=style&index=0&id=507040bd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507040bd",
  null
  
)

export default component.exports